import { render, staticRenderFns } from "./AgregarReparto.vue?vue&type=template&id=02666b56"
import script from "./AgregarReparto.vue?vue&type=script&lang=js"
export * from "./AgregarReparto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports